import React, { useState } from 'react';
import './ProfilePopup.css';

const ProfilePopup = ({ isOpen, onClose, userData }) => {
  const [copied, setCopied] = useState(false);
  
  if (!isOpen || !userData) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCopy = async () => {
    const phoneNumber = userData.employee_mobile ? `+91${userData.employee_mobile}` : '';
    
    if (phoneNumber) {
      try {
        await navigator.clipboard.writeText(phoneNumber);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (err) {
        console.error('Failed to copy phone number:', err);
      }
    } else {
      console.warn('Phone number not available');
    }
  };

  const handleViewProfile = () => {
    window.location = `/user-detail/${userData.user_id}`;
  };

  return (
    <div className="profile-popup-overlay" onClick={handleBackdropClick}>
      <div className="profile-popup-container">
        <div className="profile-popup-header"></div>
        
        <div className="profile-popup-card">
          <div className="profile-popup-avatar">
            <img 
              src={userData.profile_image && userData.profile_image !== "" 
                ? (userData.profile_image.includes("https://") 
                  ? userData.profile_image 
                  : `${process.env.REACT_APP_BACKEND_BASE_URL}/${userData.profile_image}`)
                : "/assets/images/profile-avatar.png"
              } 
              alt="Profile" 
              className="profile-popup-img"
            />
          </div>

          <div className="profile-popup-rating">
            <div className="rating-badge">
              <i className="fa fa-star"></i>
              <span className="rating-value">{userData.user_rating || 0}</span>
            </div>
            <div className="rating-count">{userData.no_of_people_reviewed|| 0}</div>
          </div>

          <h2 className="profile-popup-name">{userData.user_name}</h2>

          <p className="profile-popup-location">{userData.location}</p>

          <a 
            href="#" 
            className="profile-popup-link"
            onClick={(e) => {
              e.preventDefault();
              handleViewProfile();
            }}
          >
            View Profile
          </a>

          <div className="profile-popup-separator"></div>

          <div className="profile-popup-contact">
            <div className="contact-header">INDIA - MOBILE</div>
            <div className="contact-info">
              <span className="contact-number">+91-{userData.employee_mobile}</span>
              <div className="contact-actions">
                <button 
                  className="contact-btn copy-btn"
                  onClick={handleCopy}
                  title={copied ? "Copied!" : "Copy number"}
                >
                  <i className={copied ? "fa fa-check" : "fa fa-copy"}></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-popup-footer"></div>
      </div>
    </div>
  );
};

export default ProfilePopup;
